export function getUpdatedBillingMethodQuoteItemAttributes({
  quoteId,
  policyQuoteItem,
  attributeTypes,
  newValue,
}: {
  quoteId: string;
  policyQuoteItem: any;
  attributeTypes: any;
  newValue: string;
}) {
  const attributesArray = [
    {
      id: attributeTypes.billingMethod.attribute?.id,
      quoteItemAttributeTypeId: attributeTypes.billingMethod.id,
      value: newValue,
    },
  ];

  const request = {
    quoteId,
    quoteItems: [
      {
        id: policyQuoteItem.id,
        quoteItemAttributes: attributesArray,
      },
    ],
  };
  return request;
}
